<template>
  <Main>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <strong>{{ this.titlePage }}</strong>

            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                :disabled="isEditable"
                color="red darken-1"
                v-model="CUSTOMER_ID_REF"
                label="CUSTOMER ID REF"
                required
              ></v-text-field>
              <!-- CUSTOMER NAME -->
              <v-autocomplete
                :disabled="isEditable"
                v-model="CUSTOMER"
                :items="customerList"
                :loading="isPreparingForm"
                item-text="CUSTOMER_NAME"
                item-value="CUSTOMER_NAME"
                label="CUSTOMER NAME"
                color="red darken-1"
                @keyup="populateCustomerList($event.target.value)"
                :return-object="true"
                @change="updateCustIDRef()"
              ></v-autocomplete>
              <!-- BISNIS -->
              <v-autocomplete
                :disabled="isEditable"
                v-model="BISNIS"
                :items="bisnisTypeList"
                :loading="isPreparingForm"
                item-text="BISNIS_GROUP"
                item-value="BISNIS_GROUP"
                label="BISNIS"
                color="red darken-1"
              ></v-autocomplete>
              <!-- TYPE DESC -->
              <v-autocomplete
                v-model="TYPE_DESC"
                :items="typeDescList"
                :loading="isPreparingForm"
                item-text="SLS_PERSON_TYPE"
                item-value="SLS_PERSON_TYPE"
                label="TYPE DESC"
                color="red darken-1"
              ></v-autocomplete>
              <!-- POSITION -->
              <v-autocomplete
                :disabled="isEditable"
                v-model="POSITION"
                :items="positionList"
                :loading="isPreparingForm"
                item-text="SALESREP_POSITION_CODE"
                item-value="SALESREP_POSITION_CODE"
                label="POSITION"
                color="red darken-1"
              ></v-autocomplete>
              <!-- ADD SALESMAN POSITION 
                        <v-text-field color="red darken-1"
                v-model="ADD_SALESMAN_POSITION"
                label="ADD SALESMAN POSITION"
                required
              ></v-text-field>-->
              <v-autocomplete
                v-model="ADD_SALESMAN_POSITION"
                :items="additionalTypeList"
                :loading="isPreparingForm"
                item-text="ROLE_POSITION_CODE"
                item-value="ROLE_POSITION_CODE"
                label="ADD SALESMAN POSITION"
                color="red darken-1"
              ></v-autocomplete>

              <!-- START DATE -->
              <v-menu
                :disabled="isEditable"
                v-model="isShowStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :disabled="isEditable"
                    color="red darken-1"
                    v-model="STARTDATE"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="STARTDATE"
                  @input="isShowStartDate = false"
                  color="red darken-1"
                ></v-date-picker>
              </v-menu>
              <!-- END DATE -->
              <v-menu
                :disabled="isEditable"
                v-model="isShowEndDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :disabled="isEditable"
                    color="red darken-1"
                    v-model="ENDDATE"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="red darken-1"
                  v-model="ENDDATE"
                  @input="isShowEndDate = false"
                >
                  <template>
                    <v-card-actions class="w-100 float-right">
                      <v-btn small color="warning" @click="setEndDateOfThisMonth()"
                        >Select End Date of This Month</v-btn
                      >
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
              <v-btn @click="confirmModal(submit)" color="success" class="mt-6">{{
                this.titlePage
              }}</v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will save input data to database. Please give confirmation before you
          continue.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

export default {
  components: {
    Main,
  },
  data() {
    return {
      isEditable: true,
      ASSIGNMENT_MAP_ID: 0,
      CUSTOMER_ID_REF: "",
      CUSTOMER_NAME: "",
      CUSTOMER: "",
      BISNIS: "",
      TYPE_DESC: "",
      POSITION: "",
      ADD_SALESMAN_POSITION: "",
      STARTDATE: "",
      ENDDATE: "",
      methodAction: "",
      titlePage: "",
      snackbarText: "",
      // List AutoComplete
      arrRow: [],
      customerList: [],
      typeDescList: [],
      positionList: [],
      bisnisTypeList: [],
      selectedCustomer: [],
      additionalTypeList: [],
      // Validator
      valid: false,
      isPreparingForm: false,
      isShowSnackbar: false,
      isOpenModalConfirm: false,
      isLoading: false,
      isShowStartDate: false,
      isShowEndDate: false,
    };
  },
  mounted() {
    // this.populateCustomerList();
    this.populateTypePositionList();
    this.populateBisnisList();
    if (this.$route.params.salesrepMapId) {
      this.getMappingById(this.$route.params.salesrepMapId);
      this.titlePage = "Edit Mapping Sales Assignment";
    } else {
      this.arrRow.push({
        customerId: "",
        customerName: "",
        customerList: [],
        bisnis: "",
        typeDesc: "",
        position: "",
        addSalesmanPosition: "",
        startDate: "",
        endDate: moment(new Date("4001-12-31")).format("YYYY-MM-DD"),
        userIdUpdate: JSON.parse(localStorage.getItem("userData")).USER_ID,
      });
    }
  },
  methods: {
    setEndDateOfThisMonth() {
      this.ENDDATE = moment().endOf("months").format("YYYY-MM-DD");
    },
    updateCustIDRef() {
      this.CUSTOMER_NAME = this.CUSTOMER.CUSTOMER_NAME;
      this.CUSTOMER_ID_REF = this.CUSTOMER.CUSTOMER_ID_REF;
    },
    populateAddPosition(branchCode) {
      this.$http
        .post("/structure/role/selectAdditionalType", {
          branchCode: branchCode,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          const { data } = res.data;
          this.additionalTypeList = data;
        })
        .catch((err) => {
          this.isPreparingForm = false;
          this.showSnackbar(err.toString());
        });
    },
    populateCustomerList(keyword) {
      this.$http
        .post("/mapping-sales-assignment/listCustomer", {
          keyword: keyword,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          // this.isLoading = false;
          const { data } = res.data;
          this.customerList = data;
        })
        .catch((err) => {
          // this.isLoading = false;
          this.showSnackbar(err.toString());
        });
      // setTimeout(() => {
      // }, 1500);
    },
    populateTypePositionList() {
      this.isLoading = true;
      this.$http
        .post("/mapping-sales-assignment/listPosition", {
          orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { data } = res.data;
          this.positionList = data;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    populateBisnisList() {
      this.isLoading = true;
      this.$http
        .get("/mapping-sales-assignment/listBisnis", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { data } = res.data;
          this.bisnisTypeList = data;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    getMappingById(ID) {
      this.isLoading = true;
      this.$http
        .post("/mapping-sales-assignment/selectByID", {
          ASSIGNMENT_MAP_ID: ID,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { data } = res.data;
          console.log("getMappingById FETCH : ", res);

          this.getTypeDescList(data.BISNIS, data.CUSTOMER_ID);
          this.populateCustomerList(data.CUSTOMER_NAME);
          this.populateAddPosition(data.BRANCH_CODE_POSITION);

          // FILL DATA FROM API TO FORM
          this.ASSIGNMENT_MAP_ID = ID;
          this.CUSTOMER_ID_REF = data.CUSTOMER_ID;
          this.CUSTOMER = data.CUSTOMER_NAME;
          this.CUSTOMER_NAME = data.CUSTOMER_NAME;
          this.BISNIS = data.BISNIS;
          this.TYPE_DESC = data.TYPE_DESC;
          this.POSITION = data.POSITION_CODE;
          this.ADD_SALESMAN_POSITION = data.ADD_SALESMAN_POSITION;
          this.STARTDATE = moment(data.ASSIGNMENT_START_DATE).format("YYYY-MM-DD");
          this.ENDDATE = moment(data.ASSIGNMENT_END_DATE).format("YYYY-MM-DD");
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    getTypeDescList(BISNIS_ID, CUSTOMER_ID) {
      this.isLoading = true;
      this.$http
        .post("/mapping-sales-assignment/listTypeDesc", {
          BusinessGroup: BISNIS_ID,
          customer_id:CUSTOMER_ID
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { data } = res.data;
          this.typeDescList = data;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    submit() {
      let data = {
        ASSIGNMENTMAPID: this.ASSIGNMENT_MAP_ID,
        POSITIONCODE: this.POSITION,
        ADDSALESMANPOSITION: this.ADD_SALESMAN_POSITION,
        CUSTOMERID: this.CUSTOMER_ID_REF,
        CUSTOMERNAME: this.CUSTOMER_NAME,
        BISNIS: this.BISNIS,
        TYPEDESC: this.TYPE_DESC,
        ASSIGNMENTSTARTDATE: this.STARTDATE,
        ASSIGNMENTENDDATE: this.ENDDATE,
        ASSIGNMENTUSERIDUPDATE: JSON.parse(localStorage.getItem("userData")).USER_ID,
      };

      console.log("UPDATE DATA : ", data);

      this.isLoading = true;
      this.$http
        .post("/mapping-sales-assignment/update", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          const { success, message } = res.data;

          console.log(res);

          if (success) {
            this.isLoading = false;
            this.$router.push({
              path: `/mapping-sales-assignment/overview`,
            });
          } else {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    validateRow(obj) {
      if (
        obj.customerId != "" &&
        obj.customerName != "" &&
        obj.bisnis != "" &&
        obj.typeDesc != "" &&
        obj.position != "" &&
        obj.addSalesmanPosition != "" &&
        obj.startDate != "" &&
        obj.endDate != ""
      ) {
        return true;
      } else return false;
    },
    onCustomerSelected(index) {
      this.arrRow[index].customerId = this.arrRow[index].customerList.CUSTOMER_ID;
      this.arrRow[index].customerName = this.arrRow[index].customerList.CUSTOMER_NAME;
    },
    onbisnisSelected(bisnisID, index) {
      this.arrRow[index].bisnis = bisnisID;
      this.getTypeDescList(bisnisID, index);
    },
    onTypeDescSelected(typeDescID, index) {
      this.arrRow[index].typeDesc = typeDescID;
    },
    onPositionSelected(positionID, index) {
      this.arrRow[index].position = positionID;
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
